import { Box, Typography } from "@wealthx/ui";
import { useCompanyInfo } from "../../hooks";
import "./partner-logo-banner.scss";

const WealthXLightLogoUrl = `${process.env.GATSBY_STATIC_ASSET_URL}/wealthx-light-logo.svg`;

const PartnerLogoBanner = () => {
  const { data: companyInfo } = useCompanyInfo();
  const logoUrl = companyInfo?.theme?.logoDarkUrl || companyInfo?.theme?.logoUrl || "";
  if (!logoUrl) {
    return <img className="partner-logo-banner__logo" src={WealthXLightLogoUrl} alt="logo" />;
  }
  return (
    <Box className="partner-logo-banner__banner">
      <img className="partner-logo-banner__logo" src={logoUrl} alt="logo" />
      <Box className="partner-logo-banner__powered-by">
        <Typography className="partner-logo-banner__powered-by-text">Powered by</Typography>
        <img
          className="partner-logo-banner__wealthx-logo"
          src={WealthXLightLogoUrl}
          alt="wealthx"
        />
      </Box>
    </Box>
  );
};

export default PartnerLogoBanner;
